import _dimensionType from './_dimensionType';

function dimension  (_val) {
  this.__attrs__.dimensions.push(_dimensionType(_val));
  return this;
}

export default dimension;


// WEBPACK FOOTER //
// ../node_modules/daisy-chart/src/layouts/default/dimension.js